import _ from 'lodash'
import { _globalCollectionName } from "../../../projectSpecific/sports/dbActions/globals"
import { createStaticViewFromDataCollections } from '../../common/convert'
import { createInitials } from '../../common/dataAdjust'
import { dataFix } from "../../common/dataFix"
import { ammendAllDates, getNow } from '../../common/dateFormatting'
import { gEnums } from '../../enums/globalEnums'
import { createRefPath_client, createRefPath_event } from "../../firestoreData/appData/appRefPaths"
import { getStaticViews } from "../../firestoreData/staticViews/updateStaticViews"
import { updateLinkHelpers } from '../../firestoreData/updates/subUpdates/fsUpdate_dataLInks'
import { _appUserPresenceCollection } from "./AppUserReducer"
import { dispatchConfirmationTypes, grts, responseHandlers, responseReducers } from "./reducerHelpers/dispatchProps"
import { updateDocumentHelpers } from 'global/firestoreData/updates/subUpdates/fsUpdate_document'

const rts = {
  handleClear_appProfileData: 'handleClear_appProfileData',
  handleClear_regDataDocuments: 'handleClear_regDataDocuments',
  handleCreate_appDataDocuments: 'handleCreate_appDataDocuments',
  handleCreate_appDataLinks: 'handleCreate_appDataLinks',
  handleCreate_appProfiles: 'handleCreate_appProfiles',
  handleCreate_staticViews: 'handleCreate_staticViews',
  handleGet_appDataDocuments: 'handleGet_appDataDocuments',
  handleGet_eventStaticViews: 'handleGet_eventStaticViews',
  handleInit_eventInfo: 'handleInit_eventInfo',
  handleClear_googleSheetsData: 'handleClear_googleSheetsData',
  handleSet_appDataDocuments: 'handleSet_appDataDocuments',
  // handleSet_appGlobalData: 'handleSet_appGlobalData',
  handleSet_appProfileData: 'handleSet_appProfileData',
  handleSet_appScheduledNotifications: 'handleSet_appScheduledNotifications',
  handleSet_appUserSnapshot: 'handleSet_appUserSnapshot',
  handleSet_appUserUrls: 'handleSet_appUserUrls',
  handleSet_eventCacheData: 'handleSet_eventCacheData',
  handleSet_eventData: 'handleSet_eventData',
  handleSet_eventInitData: 'handleSet_eventInitData',
  handleSet_eventStaticView: 'handleSet_eventStaticView',
  handleSet_eventStaticViews: 'handleSet_eventStaticViews',
  handleSet_googleSheetsStaticViews: 'handleSet_googleSheetsStaticViews',
  handleSet_demoData: 'handleSet_demoData',
  handleSet_googleSheetsData: 'handleSet_googleSheetsData',
  handleUpdate_eventStatus: 'handleUpdate_eventStatus',
  handleUpdate_appUserSnapshot: 'handleUpdate_appUserSnapshot',
  ...grts
}

const eventCreateTypes = {
  appDataDocuments: 'appDataDocuments',
  appDataLinks: 'appDataLinks',
  staticViews: 'staticViews',
}

export const eventInfoReducer = (state, action) => {

  const { eventCollectionsData, appDataDocuments, regDataDocuments, database_fns } = state
  const { type, dispatch, pathViews } = action

  const eventInfo_handlers = eventInfoHandlers(dispatch)
  // handleSet_appDataLinks
  const { handleSet_appGlobalData, handleSet_eventStaticViews } = eventInfo_handlers

  const _eventCollectionsData = eventCollectionsData ? _.cloneDeep(eventCollectionsData) : {}

  switch (type) {

    case rts.handleSet_eventCacheData:
      const { cache_eventInfo } = action
      const { appGlobalData } = cache_eventInfo ?? {}
      return { ...state, cache_eventInfo, appGlobalData }

    case rts.handleInit_eventInfo:
      if (action.eventInfo?.appDataDocuments) {
        const { _staticViews, _appDataLinks, _appDataDocs } = ammendAppDataDocs(action.eventInfo.appDataDocuments, state.aps_viewItems)
        const _state = {
          ...state,
          ...action.eventInfo,
          appDataDocuments: _appDataDocs,
          staticViews: _staticViews,
          appDataLinks: _appDataLinks,
          staticViewKeys: _staticViews ? Object.keys(_staticViews) : []
        }
        return _state
      }
      return { ...state, ...action.eventInfo }

    case rts.handleSet_eventData:
      return { ...state, eventData: action.eventData }

    case rts.handleSet_appUserSnapshot:
      return { ...state, appUserSnapshot: action.appUserSnapshot }

    case rts.handleSet_appScheduledNotifications:
      return { ...state, appScheduledNotifications: action.appScheduledNotifications }

    case rts.handleClear_regDataDocuments:
      return { ...state, regDataDocuments: null }

    case rts.handleSet_appDataDocuments:
      const { appDataDocuments: appDd, fromReg } = action
      const _appDd = _.cloneDeep(appDd)
      const { aps_viewItems } = state
      if (_appDd && aps_viewItems) {
        const _viks = _.keys(aps_viewItems)
        _.forEach(_viks, viKey => {
          if (!_appDd[viKey]) {
            _appDd[viKey] = {}
          }
        })
      }

      updateLinkHelpers.autoSyncBidirectional(_appDd)
      const { svs, _appDataLinks } = ammendAppDataLinks(_appDd, state.aps_viewItems)
      const svsz = createStaticViewFromDataCollections(_appDd, state.aps_viewItems)

      return {
        ...state,
        appDataDocuments: regDataDocuments ? regDataDocuments : appDd,
        regDataDocuments: fromReg ? appDd : regDataDocuments,
        appDataLinks: _appDataLinks,
        edf: 'firebase',
        staticViews: svsz,
        staticViewKeys: svsz ? Object.keys(svsz) : []
      }

    case rts.handleSet_demoData:
      return {
        ...state,
        appDataDocuments: action.demoPreview.appDataDocuments,
        appDataLinks: action.demoPreview.appDataLinks,
        edf: 'demoData'
      }

    case rts.handleSet_googleSheetsData:
      const { svs: _svs, _appDataLinks: _appDataLinksGs } = ammendAppDataLinks(action.googleSheetsData, state)
      return {
        ...state,
        googleSheetsData: action.googleSheetsData,
        googleSheetsPreview: action.googleSheetsPreview,
        appDataLinks: action.googleSheetsPreview?.appDataLinks,
        edf: 'googleSheets'
      }

    case rts.handleClear_googleSheetsData:
      return {
        ...state,
        googleSheetsData: null,
        googleSheetsPreview: null,
        appDataDocuments: null,
        appDataLinks: null,
        edf: 'none'
      }

    case rts.handleSet_eventInitData:

      const { data, cbProps } = action
      const { collectionName } = cbProps
      _eventCollectionsData[collectionName] = data
      const collectionKeys = Object.keys(_eventCollectionsData)

      const _linkedCollections = {}

      _.forEach(_eventCollectionsData, (cd, collectionItemKey) => {
        _linkedCollections[collectionItemKey] = {};
        _.forEach(cd, (cdi) => {
          _.forEach(_.pick(cdi, collectionKeys), (value, key) => {
            _linkedCollections[collectionItemKey][key] ||= value;
          });
        });
      });

      return {
        ...state,
        eventCollectionsData: _eventCollectionsData
      }

    case rts.handleGet_eventStaticViews:
      getStaticViews(database_fns, action.pathViews, handleSet_eventStaticViews)
      return state

    case rts.handleClear_appProfileData:
      return { ...state, appProfileData: null }

    case rts.handleSet_appProfileData:

      const { d: _appUserProfileData } = action
      const { clientProfiles: _clientProfiles, attendees } = _appUserProfileData ?? {}

      if (state.pathViews.events) {

        if (_clientProfiles) {
          _appUserProfileData.eventProfiles = _.pickBy(_clientProfiles, profile => _.has(profile.events, state.pathViews.events))
        }

        if (attendees) {
          const attendeesByEmail = _.keyBy(attendees, 'email');

          const nonProfiledAttendees = _.pickBy(
            attendeesByEmail,
            (attendee, email) => {
              const profile = _clientProfiles?.[email]
              return !profile || !profile.initials || !profile.displayName
            }
          );

          const nonEventProfiles = _.pickBy(
            attendeesByEmail,
            (attendee, email) => {
              const profile = _appUserProfileData?.eventProfiles?.[email];
              return !_.get(profile, ['events', state?.pathViews?.events]);
            }
          );

          ammendNonProfiled(nonProfiledAttendees, state)
          ammendNonEvents(nonEventProfiles, state)

          _appUserProfileData.nonProfiledAttendees = nonProfiledAttendees
          _appUserProfileData.nonEventProfiles = nonEventProfiles
        }
      }
      return { ...state, appProfileData: _appUserProfileData }

    case rts.handleSet_eventStaticView:
      const svszz = state.staticViews ? _.cloneDeep(state.staticViews) : {}
      svszz[action.staticView] = action.staticViewData
      return { ...state, staticViews: svszz }

    case rts.handleSet_eventStaticViews:
      let { staticViews, pathViews: pathViews_results } = action.results ?? {}
      // if ((_.isEmpty(staticViews)) && appDataDocuments) {
      //   staticViews = createStaticViewFromDataCollections(appDataDocuments, state.aps_viewItems)
      // }
      if (appDataDocuments) {
        staticViews = createStaticViewFromDataCollections(appDataDocuments, state.aps_viewItems)
      }
      return { ...state, staticEventKey: pathViews_results.events }
    // return { ...state, staticEventKey: pathViews_results.events, staticViews, staticViewKeys: staticViews ? Object.keys(staticViews) : [] }

    case rts.handleSet_appUserUrls:
      const { profileUrls, appUsersInfo } = action ?? {}
      const { clientProfiles } = appUsersInfo ?? {}
      return { ...state, appUserUrls: profileUrls, clientProfiles }

    case rts.handleSet_googleSheetsStaticViews:
      return { ...state, staticViews_gs: action.staticViews_gs }

    case rts.handleUpdate_eventStatus:
      const { events: eventKey } = pathViews
      const _eventData = _.cloneDeep(action.eventData)
      dataFix.ammendDeleteFields(_eventData)
      const _refPath = createRefPath_client(pathViews, ['events', eventKey])
      // database_fns.set_doc(_refPath, _eventData, true)
      return state

    case rts.handleUpdate_appUserSnapshot:
      updateAppUserSnapshot(database_fns, pathViews, action.appUserAuthList, action.callback)
      return state

    case rts.handleGet_appDataDocuments:
      getEventData(database_fns, state, action.selectedViewItemKey, action.callback)
      return state

    case rts.handleCreate_appDataDocuments:
      createEventData(database_fns, state, eventCreateTypes.appDataDocuments, action.selectedViewItemKey, action.commit, action.callback)
      return state

    case rts.handleCreate_appDataLinks:
      createEventData(database_fns, state, eventCreateTypes.appDataLinks, null, action.commit, action.callback)
      return state

    case rts.handleCreate_staticViews:
      createEventData(database_fns, state, eventCreateTypes.staticViews, null, action.commit, action.callback)
      return state

    case rts.handleCreate_appProfiles:
      createAppProfiles(state)
      return state

    case rts.handleStartUpdate:
    case rts.handleStopUpdate:
    case rts.handleCloseConfirmation:
    case rts.updateSuccess:
    case rts.updateSuccessAlt:
    case rts.updateError:
      return responseReducers(state, action, { dispatch, dispatchConfirmationType: dispatchConfirmationTypes.closeAfterConfirmation, questionProps: null })

    default:
      return state
  }
}

export const eventInfoInitialState = (initState) => {
  return { ...initState, appData: {}, eventCollectionsData: {}, missingSvDatas: {} }
};

export const eventInfoHandlers = (dispatch) => {
  return {
    handleClear_appProfileData: () => { dispatch({ type: rts.handleClear_appProfileData, dispatch }) },
    handleClear_googleSheetsData: () => { dispatch({ type: rts.handleClear_googleSheetsData }) },
    handleClear_regDataDocuments: () => { dispatch({ type: rts.handleClear_regDataDocuments, dispatch }) },
    handleCreate_appDataDocuments: (selectedViewItemKey, commit, callback) => { dispatch({ type: rts.handleCreate_appDataDocuments, dispatch, selectedViewItemKey, commit, callback }) },
    handleCreate_appDataLinks: (commit, callback) => { dispatch({ type: rts.handleCreate_appDataLinks, dispatch, commit, callback }) },
    handleCreate_appProfiles: () => { dispatch({ type: rts.handleCreate_appProfiles, dispatch }) },
    handleCreate_staticViews: (commit, callback) => { dispatch({ type: rts.handleCreate_staticViews, dispatch, commit, callback }) },
    handleGet_appDataDocuments: (selectedViewItemKey, callback) => { dispatch({ type: rts.handleGet_appDataDocuments, dispatch, selectedViewItemKey, callback }) },
    handleGet_eventStaticViews: (pathViews) => { dispatch({ type: rts.handleGet_eventStaticViews, dispatch, pathViews }) },
    handleInit_eventInfo: (eventInfo) => { dispatch({ type: rts.handleInit_eventInfo, dispatch, eventInfo }) },
    handleSet_appDataDocuments: (appDataDocuments, dataLinks, fromReg) => { dispatch({ type: rts.handleSet_appDataDocuments, dispatch, appDataDocuments, dataLinks, fromReg }) },
    // handleSet_appGlobalData: (d, fromCache) => { dispatch({ type: rts.handleSet_appGlobalData, dispatch, d, fromCache }) },
    handleSet_appProfileData: (d) => { dispatch({ type: rts.handleSet_appProfileData, dispatch, d }) },
    handleSet_appScheduledNotifications: (appScheduledNotifications) => { dispatch({ type: rts.handleSet_appScheduledNotifications, dispatch, appScheduledNotifications }) },
    handleSet_appUserSnapshot: (appUserSnapshot) => { dispatch({ type: rts.handleSet_appUserSnapshot, dispatch, appUserSnapshot }) },
    handleSet_appUserUrls: (profileUrls, appUsersInfo) => { dispatch({ type: rts.handleSet_appUserUrls, dispatch, profileUrls, appUsersInfo }) },
    handleSet_demoData: (demoPreview) => { dispatch({ type: rts.handleSet_demoData, dispatch, demoPreview }) },
    handleSet_eventCacheData: (pathViews, cache_eventInfo) => { dispatch({ type: rts.handleSet_eventCacheData, dispatch, pathViews, cache_eventInfo }) },
    handleSet_eventData: (eventData) => { dispatch({ type: rts.handleSet_eventData, dispatch, eventData }) },
    handleSet_eventInitData: (data, cbProps) => { dispatch({ type: rts.handleSet_eventInitData, dispatch, data, cbProps }) },
    handleSet_eventStaticView: (staticView, staticViewData) => { dispatch({ type: rts.handleSet_eventStaticView, dispatch, staticView, staticViewData }) },
    handleSet_eventStaticViews: (results) => { dispatch({ type: rts.handleSet_eventStaticViews, dispatch, results }) },
    handleSet_googleSheetsData: (googleSheetsData, googleSheetsPreview) => { dispatch({ type: rts.handleSet_googleSheetsData, dispatch, googleSheetsData, googleSheetsPreview }) },
    handleSet_googleSheetsStaticViews: (staticViews_gs) => { dispatch({ type: rts.handleSet_googleSheetsStaticViews, dispatch, staticViews_gs }) },
    handleUpdate_appUserSnapshot: (pathViews, appUserAuthList) => { dispatch({ type: rts.handleUpdate_appUserSnapshot, dispatch, pathViews, appUserAuthList }) },
    handleUpdate_eventStatus: (eventData) => { dispatch({ type: rts.handleUpdate_eventStatus, dispatch, eventData }) },
    ...responseHandlers(dispatch)
  }
}

const ammendAppDataLinks = (appDd, aps_viewItems) => {

  const _updatedCollections = updateLinkHelpers.enforceBidirectionalLinks(appDd, false)

  const _appDataLinks = updateLinkHelpers.createAppLinks(null, appDd)
  delete appDd.staticViews
  const svs = createStaticViewFromDataCollections(appDd, aps_viewItems)
  ammendAllDates(appDd, false)
  return { svs, _appDataLinks }
}

/**
 * update_doc: appUsers
 * @param {*} database_fns 
 * @param {*} pathViews 
 * @param {*} appUserAuthList 
 * @param {*} callback 
 */
const updateAppUserSnapshot = (database_fns, pathViews, appUserAuthList, callback) => {
  const alts = gEnums.authListTypes
  const _currents = {
    recent: appUserAuthList && appUserAuthList[alts.recent] ? appUserAuthList[alts.recent].length : 0,
    found: appUserAuthList && appUserAuthList[alts.found] ? appUserAuthList[alts.found].length : 0,
    notFound: appUserAuthList && appUserAuthList[alts.notFound] ? appUserAuthList[alts.notFound].length : 0
  }
  const _appUsers = {
    recent: appUserAuthList && appUserAuthList[alts.recent] ? _.map(appUserAuthList[alts.recent], 'displayName') : null,
    found: appUserAuthList && appUserAuthList[alts.found] ? _.map(appUserAuthList[alts.found], 'displayName') : null,
    notFound: appUserAuthList && appUserAuthList[alts.notFound] ? _.map(appUserAuthList[alts.notFound], 'displayName') : null,
  }
  const refPath = createRefPath_event(pathViews, ['_appUserSnapshot', 'currentAppUsers'])
  const dataToUpdate = {
    status: _currents,
    appUsers: _appUsers,
    timestamp: getNow()
  }
  // database_fns.update_doc(refPath, dataToUpdate, callback)
  database_fns.update_docc({
    refPath: refPath,
    data: dataToUpdate,
    callback
  })

}

const getEventData = async (database_fns, state, selectedViewItemKey, callback) => {

  const { pathViews, aps_viewItems: viewItems, staticViews } = state
  const eventData_array = await getAllEventDataPromise(database_fns, pathViews, viewItems, selectedViewItemKey)

  let count = 0

  // load up the documentsData
  const documentsData = {}

  _.forEach(viewItems, (viewItem, vik) => {
    let allow;

    if (selectedViewItemKey) {
      allow = selectedViewItemKey === vik
    } else {
      allow = true
    }

    if (allow) {
      // do we have any data
      if (!_.isEmpty(eventData_array[count])) {
        // add the data to the documentsData[viewItemKey]
        documentsData[vik] = eventData_array[count]
      }
      count++
    }
  })

  callback(documentsData)
}

const createEventData = async (database_fns, state, eventCreateType, selectedViewItemKey, commit, callback) => {

  const { pathViews, aps_viewItems: viewItems } = state

  const eventData_array = await getAllEventDataPromise(database_fns, pathViews, viewItems, selectedViewItemKey)

  let count = 0

  // load up the documentsData
  const documentsData = {}
  _.forEach(viewItems, (viewItem, vik) => {
    let allow;

    if (selectedViewItemKey) {
      allow = selectedViewItemKey === vik
    } else {
      allow = true
    }

    if (allow) {
      // do we have any data
      if (!_.isEmpty(eventData_array[count])) {
        // add the data to the documentsData[viewItemKey]
        documentsData[vik] = eventData_array[count]
      }
      count++
    }
  })

  switch (eventCreateType) {
    case eventCreateTypes.appDataDocuments:
      const updateResults = await updateDocumentHelpers.update_allDocuments(database_fns, pathViews, documentsData)
      const timeStampResults = await timeStampsHelpers.updateEventTimeStamps_db(database_fns, pathViews, documentsData)
      callback && callback(updateResults)
    case eventCreateTypes.appDataLinks:
      const _appDataLinks = await createAppLinks(pathViews, staticViews, documentsData, commit)
      callback && callback(_appDataLinks)
  }

}

const getAllEventDataPromise = (database_fns, pathViews, viewItems, selectedViewItemKey) => {
  const promises = []
  _.forEach(viewItems, (viewItem, viewItemKey) => {
    let allowViewItem = false
    if (selectedViewItemKey) {
      allowViewItem = viewItemKey === selectedViewItemKey
    } else {
      allowViewItem = true
    }
    if (allowViewItem) {
      const _refPath = createRefPath_event(pathViews, [viewItemKey])
      promises.push(database_fns.get_data({ refPath: _refPath, opts: { cbProps: { collectionName: viewItemKey } } }))
    }
  })
  return Promise.all(promises)
}

const createAppProfiles = async (state) => {
  const { appUserCollections, appDataDocuments, pathViews, mainFixedCaption } = state ?? {}
  const { events: eventKey } = pathViews ?? {}
  if (appUserCollections && appDataDocuments) {
    const profiles = {}
    _.forEach(appUserCollections, (appUserCollection) => {
      const appDataDocument = appDataDocuments[appUserCollection]
      _.forEach(appDataDocument, (appDataDoc, _itemKey) => {
        const { email, firstName, lastName } = appDataDoc ?? {}
        profiles[email] = {
          email,
          displayName: firstName + ' ' + lastName,
          initials: createInitials(firstName + ' ' + lastName),
          events: {
            [eventKey]: {
              appUserKey: _itemKey,
              name: mainFixedCaption
            }
          }
        }
      })
    })
    await createProfiles(profiles, pathViews)
  }
}

const createProfiles = async (profiles, pathViews) => {
  const promises = []
  _.forEach(profiles, (profile, key) => {
    const refPath = createRefPath_client(pathViews, ['profiles', key])
    promises.push(database_fns.set_doc(refPath, profile))
  })
  return Promise.all(promises)
}

const ammendAppDataDocs = (appDd, aps_viewItems) => {
  const _appDd = _.cloneDeep(appDd)
  if (_appDd && aps_viewItems) {
    const _viks = _.keys(aps_viewItems)
    _.forEach(_viks, viKey => {
      if (!_appDd[viKey]) {
        _appDd[viKey] = {}
      }
    })
  }
  const _appDataDocs = updateLinkHelpers.autoSyncBidirectional(_appDd)
  const { svs, _appDataLinks } = ammendAppDataLinks(_appDataDocs, aps_viewItems)
  const svsz = createStaticViewFromDataCollections(_appDataDocs, aps_viewItems)
  return { _appDataDocs, _staticViews: svsz, _appDataLinks }
}

const ammendNonProfiled = (nonProfiledAttendees, state) => {
  _.forEach(nonProfiledAttendees, (npa) => {
    npa.id = npa.email
    npa.displayName = `${npa.firstName} ${npa.lastName}`
    npa.firstName = `${npa.firstName}`
    npa.lastName = `${npa.lastName}`
    npa.initials = createInitials(`${npa.firstName} ${npa.lastName}`)
    npa.events = {
      [state.pathViews.events]: {
        eventKey: state.pathViews.events,
        appUserKey: npa._itemKey,
        name: state?.eventData?.name
      }
    }
    delete npa.key
    delete npa._itemKey
  })
}

const ammendNonEvents = (nonEventProfiles, state) => {
  _.forEach(nonEventProfiles, (nep) => {
    if (!nep.events) { nep.events = {} }
    nep.events[state.pathViews.events] = {
      eventKey: state.pathViews.events,
      appUserKey: nep._itemKey,
      name: state?.eventData?.name
    }
    delete nep.key
    delete nep._itemKey
  })
}